<template>
  <div>
    <div class="panel m-3">
      <PanelHeader :panel-header="doctorName || 'Arzt'" />
      <div class="container pt-3 pb-3">
        <div
          v-if="dataObject"
          class="stammdaten"
        >
          <div class="stammdaten-facts">
            <p class="title is-5 mb-2">
              {{ factsLine }}
            </p>
            <template v-if="addressLine">
              <hr class="my-2">
              <p>{{ addressLine }}</p>
            </template>
          </div>
        </div>
      </div>
    </div>

    <section class="mx-5 my-2">
      <div
        class="buttons"
        style="display: flex"
      >
        <b-button
          class="is-primary"
          tag="router-link"
          to="/doctor"
        >
          Zurück
        </b-button>
        <b-button
          class="is-danger"
          style="margin-left: auto"
          @click="isDeleteCheck = true"
        >
          Löschen
        </b-button>
        <b-button
          class="is-primary"
          @click="triggerEdit"
        >
          Bearbeiten
        </b-button>
      </div>
    </section>
    <ModalComponent
      v-if="isDeleteCheck && dataObject"
      :item="doctorName"
      :is-delete-check="isDeleteCheck"
      :is-loading="isLoading"
      :cancel="() => isDeleteCheck = false"
      :submit="submitDelete"
    />
  </div>
</template>

<script>
/**
 * This file is for viewing a focused doctor.
 */
import Parse from "parse/dist/parse.min.js";
import PanelHeader from "@/components/helperComponents/PanelHeader";
import ModalComponent from "@/components/helperComponents/ModalComponent";
import { negativeFeedBack, positiveFeedBack } from "@/lib/Toast";

export default {
	name: "ViewDoctor",
	components: {
		ModalComponent,
		PanelHeader,
	},
	data() {
		return {
			dataObject: undefined,
			isDeleteCheck: false,
			isLoading: false,
		};
	},
	computed: {
		doctorName() {
			const name = this.dataObject && this.dataObject.attributes.name;
			return name ? name.trim() : "";
		},
		specializationName() {
			const spec =
				this.dataObject && this.dataObject.attributes.specialization;
			const name =
				spec && spec.attributes && spec.attributes.specialization;
			return name ? name.trim() : "";
		},
		factsLine() {
			return [ this.doctorName, this.specializationName ]
				.filter(Boolean).join(", ");
		},
		addressLine() {
			if (!this.dataObject) return "";
			const a = this.dataObject.attributes;
			const city = [ a.plz, a.location ]
				.filter(Boolean).map(s => String(s).trim())
				.filter(Boolean).join(" ");
			const street = a.street ? a.street.trim() : "";
			return [ street, city ].filter(Boolean).join(", ");
		}
	},
	async mounted() {
		this.scrollToElement();
		let dataObject = this.$route.params.data;
		// Reached via browser navigation (back/forward, reload, deep
		// link): the in-memory object is gone, load it by the URL id.
		if (!dataObject && this.$route.params.id) {
			try {
				dataObject = await new Parse.Query("MedicationDoctor")
					.include("specialization")
					.get(this.$route.params.id);
			}
			catch (e) {
				console.error(e);
			}
		}
		if (!dataObject) return await this.$router.push("/doctor");
		this.dataObject = dataObject;
	},
	methods: {
		scrollToElement() {
			const el = this.$parent.$parent.$refs.scrollToMe;
			if (el) {
				el.scrollIntoView({ behavior: "smooth" });
			}
		},
		triggerEdit() {
			this.$router.push(
				{ name: "AddDoctor", params: { data: this.dataObject } });
		},
		async submitDelete() {
			this.isLoading = true;
			try {
				this.dataObject.set("deleted", true);
				await this.dataObject.save();
				this.$store.dispatch("doctors/delete", this.dataObject);
				this.isDeleteCheck = false;
				await this.$router.push("/doctor");
				positiveFeedBack(this.doctorName + " gelöscht!");
			}
			catch (e) {
				console.error(e);
				negativeFeedBack(this.doctorName + " nicht gelöscht!");
			}
			finally {
				this.isLoading = false;
			}
		}
	}
}
</script>

<style scoped>
.stammdaten {
	display: flex;
	align-items: flex-start;
	gap: 1.5rem;
	padding-left: 1.5rem;
}

.stammdaten-facts {
	text-align: left;
	min-width: 0;
}

.stammdaten-facts p {
	margin-bottom: 0.25rem;
}
</style>
